import { Injectable } from '@angular/core';


export class SubscribersInfo {

    constructor( public topics = [] ) {

    }

    get total(): number {
        return this.topics.length;
    }
    public getSubscribersAmount(topic: string = null) {
        return topic ? this.topics.filter((t) => t.match( new RegExp(topic, 'i'))).length : this.total;
    }

    public removeOneSubscriber(topic: string = null) {

        if (topic == null) {
            if (this.topics.length > 0) {
                this.topics.splice(0, 1);
            }

            return this.topics.length;
        }

        const index = this.topics.findIndex((t) => t.match( new RegExp(topic, 'i')));

        if (index >= 0) {
            this.topics.splice(index, 1);
        }

        return this.topics.length;
    }

   public registerSubscriber(topic: string = null) {
        if (topic && !this.topics.includes(topic)) {
            this.topics.push(topic.toUpperCase());
        }
    }

    public registerSubscribers(topics: string[]) {
        if (topics) {
            topics.forEach((topic) => {
                if (!this.topics.includes(topic)) this.topics.push(topic.toUpperCase());
            });
        }
    }

    public hasSubscriber(topic: string = null) {
        return this.getSubscribersAmount(topic) >= 1;
    }

    public reset(): void {
        this.topics = [];
    }
}
